module.exports = __webpack_public_path__ + "static/media/pro2.2d7c1922.png";